// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usJCh{box-sizing:border-box;position:relative;display:flex;flex-direction:column;width:336px;max-height:458px;padding:24px;border-radius:4px}.Eeec0{position:absolute;right:8px;top:8px}.ubg3E{flex-shrink:0;margin-top:8px}.BWVOX{display:flex;flex-direction:column;gap:20px;flex:1;min-height:0;overflow-y:auto;overflow-x:hidden;margin:8px 0;padding:16px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spacing0": `0px`,
	"spacing2": `2px`,
	"spacing4": `4px`,
	"spacing8": `8px`,
	"spacing12": `12px`,
	"spacing16": `16px`,
	"spacing20": `20px`,
	"spacing24": `24px`,
	"spacing32": `32px`,
	"spacing40": `40px`,
	"panel": `usJCh`,
	"closeButtonContainer": `Eeec0`,
	"pinnedTop": `ubg3E`,
	"scroll": `BWVOX`
};
export default ___CSS_LOADER_EXPORT___;
